/* collection/reducer */
import { createReducer } from "typesafe-actions";
import { PermissionActionTypes, PermissionState } from "./types";
import { fetchRequest, fetchSuccess, fetchError } from "./actions";

export const initialState: PermissionState = {
  data: null,
  errors: undefined,
  loading: false
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;

export default createReducer<PermissionState, ActionType>(initialState)
  .handleType(PermissionActionTypes.FETCH, state => {
    return { ...state, loading: true, dirty: false };
  })
  .handleType(PermissionActionTypes.FETCH_SUCCESS, (state, action) => {
    return { ...state, loading: false, data: action.payload, dirty: false };
  })
  .handleType(PermissionActionTypes.FETCH_ERROR, (state, action) => {
    return { ...state, loading: false, errors: action.payload, dirty: false };
  });
